// 浏览器userAgent
const UA = window.navigator.userAgent

export default {
  isSfExpressApp: /SFEXPRESSAPP/i.test(UA), // 是否是速运app
  isAndroid: /Android/i.test(UA), // 是否安卓系统
  isWechat: /MicroMessenger/i.test(UA), // 是否是微信环境
  isIos: /iPhone/i.test(UA), // 是否是ios系统
}
